import { render, staticRenderFns } from "./TiersForm.vue?vue&type=template&id=36143691&"
import script from "./TiersForm.vue?vue&type=script&lang=js&"
export * from "./TiersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports